import { render, staticRenderFns } from "./TableDataManagerParent.vue?vue&type=template&id=0bbd3d8f&scoped=true"
import script from "./TableDataManagerParent.vue?vue&type=script&lang=js"
export * from "./TableDataManagerParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd3d8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbd3d8f')) {
      api.createRecord('0bbd3d8f', component.options)
    } else {
      api.reload('0bbd3d8f', component.options)
    }
    module.hot.accept("./TableDataManagerParent.vue?vue&type=template&id=0bbd3d8f&scoped=true", function () {
      api.rerender('0bbd3d8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/parent/manager/component/TableDataManagerParent.vue"
export default component.exports